import { useEffect, useState } from 'react';
import { useSWRConfig } from 'swr';
import { setSessionStorageItem } from '@/lib/browserStorage';

import { enqueueSnackbar } from '@/providers/SnackbarProvider';
import { usePrivate } from './PrivateContext';
import { submitSurveyMessages } from './messages';
import { SNACKBAR_VARIANT } from '@/constants/notifications';

export function useSurveyFlow() {
  const { mutate } = useSWRConfig();

  const { userId, userProfile, userProfileApi } = usePrivate();

  const [surveyDialogOpen, setSurveyDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClickSkipQuestion = () => {
    setSessionStorageItem<boolean>('surveySkipped', true);
    setSurveyDialogOpen(false);
  };

  const handleClickSubmitSurvey = (surveyResponse: string[]) => {
    setSessionStorageItem<boolean>('surveySkipped', true);
    if (userId && userProfile && userProfileApi && !loading) {
      setLoading(true);
      userProfileApi
        .apiUserProfileSubmitSurveyPatch({
          userId,
          surveyResponseData: surveyResponse.join(','),
        })
        .then(() => {
          setSurveyDialogOpen(false);
          mutate(`/api/Animal/AnimalGroup/${userId}`);
        })
        .catch((error) => {
          enqueueSnackbar(submitSurveyMessages['submitSurvey.unexpctedError'], {
            variant: SNACKBAR_VARIANT.ERROR,
          });
          console.error(
            '[BREEDLOGIC] useSurveyFlow:handleClickSubmitSurvey - Error submitting survey',
            error,
          );
        })
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    if (userProfile && !userProfile.surveyResponse?.surveyResponseEntityId) {
      setSurveyDialogOpen(true);
    }
  }, [userProfile]);

  return {
    isSubmittingSurvey: loading,
    userProfile,
    surveyDialogOpen,
    onClickSkipQuestion: handleClickSkipQuestion,
    onClickSubmitSurvey: handleClickSubmitSurvey,
  };
}
